import { useCallback, useState } from 'react';
import { useLocation, useNavigate } from 'react-router-dom';

const useFormStatus = () => {
  const navigate = useNavigate();
  const location = useLocation();
  const [successMessage, setSuccessMessage] = useState(null);
  const [errorMessage, setErrorMessage] = useState(null);
  const { pathname } = location;

  const handleApiResult = useCallback(
    ({ data, error }) => {
      setTimeout(() => {
        setErrorMessage(null);
        setSuccessMessage(null);
      }, 5000);

      if (error) {
        setErrorMessage(error);
        setSuccessMessage(null);
      } else {
        setErrorMessage(null);
        typeof data === 'string' ? setSuccessMessage(data) : setSuccessMessage('Success !');
        if (pathname === '/copy-transfer') navigate('/');
      }
      return data;
    },
    [navigate, pathname]
  );

  return {
    successMessage,
    errorMessage,
    setSuccessMessage,
    setErrorMessage,
    handleApiResult
  };
};

export default useFormStatus;
